import { DatePicker, DatePickerProps, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocaleKey, localeTextMap } from "src/components/monitoring/senec-time-frame-selection/TimeFrameContext";
import { useTheme } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";
import { styledCalendarIcon } from "src/components/inputs/date-picker/StyledCalendarIcon";
import { styledCloseIcon } from "src/components/inputs/date-picker/StyledCloseIcon";
import "dayjs/locale/de";
import "dayjs/locale/en";
import "dayjs/locale/it";
import updateLocale from "dayjs/plugin/updateLocale";
import isoWeek from "dayjs/plugin/isoWeek";
import minMax from "dayjs/plugin/minMax";

dayjs.extend(updateLocale);
dayjs.extend(isoWeek);
dayjs.extend(minMax);

type SenecDatePickerProps = DatePickerProps<Dayjs> & {
    "data-testid"?: string;
    localeKey: LocaleKey;
};

export const SenecDatePicker = ({ localeKey, "data-testid": dataTestId = "datepicker", ...rest }: SenecDatePickerProps) => {
    const theme: SenecFPPTheme = useTheme();

    const slots = { openPickerIcon: styledCalendarIcon, clearPickerIcon: styledCloseIcon };

    dayjs.updateLocale(localeKey, {
        weekStart: localeKey === "en" ? 0 : 1,
    });

    const localeText = localeTextMap[localeKey];

    return (
        <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={localeKey} localeText={localeText}>
                <DatePicker
                    slots={slots}
                    slotProps={{
                        textField: {
                            inputProps: {
                                "data-testid": dataTestId,
                            },
                        },
                    }}
                    {...rest}
                    sx={{
                        ".MuiInputBase-root": {
                            paddingRight: "20px",
                        },
                        ...rest.sx,
                    }}
                />
            </LocalizationProvider>
        </ThemeProvider>
    );
};
